const config = {
  apiUrl: process.env.REACT_APP_FRIDAY_API_URL
};

export default config;